// extracted by mini-css-extract-plugin
export default {"tabs":"Contrataciones_tabs__iKQXa","actions":"Contrataciones_actions__XYjA8","mes":"Contrataciones_mes__-f9vC","link":"Contrataciones_link__rm9OK"};